import React from 'react';

import { IIconProps, TIconType } from '../interface';

const MenuIcon: TIconType = (props?: IIconProps) => {
	const { color } = props || {};

	return (
		<svg
			data-testid='menu'
			fill='none'
			height='30'
			viewBox='0 0 30 30'
			width='30'
		>
			<path
				d='M3.75 3.75H9.375V9.375H3.75V3.75Z'
				fill={color ? color : '#2E2E6B'}
			/>
			<path
				d='M3.75 12.1875H9.375V17.8125H3.75V12.1875Z'
				fill={color ? color : '#2E2E6B'}
			/>
			<path
				d='M3.75 20.625H9.375V26.25H3.75V20.625Z'
				fill={color ? color : '#2E2E6B'}
			/>
			<path
				d='M12.1875 3.75H17.8125V9.375H12.1875V3.75Z'
				fill={color ? color : '#2E2E6B'}
			/>
			<path
				d='M12.1875 12.1875H17.8125V17.8125H12.1875V12.1875Z'
				fill={color ? color : '#2E2E6B'}
			/>
			<path
				d='M12.1875 20.625H17.8125V26.25H12.1875V20.625Z'
				fill={color ? color : '#2E2E6B'}
			/>
			<path
				d='M20.625 3.75H26.25V9.375H20.625V3.75Z'
				fill={color ? color : '#2E2E6B'}
			/>
			<path
				d='M20.625 12.1875H26.25V17.8125H20.625V12.1875Z'
				fill={color ? color : '#2E2E6B'}
			/>
			<path
				d='M20.625 20.625H26.25V26.25H20.625V20.625Z'
				fill={color ? color : '#2E2E6B'}
			/>
		</svg>
	);
};

export default MenuIcon;
